import { endpoint } from './default';

const getClassList = () => endpoint.get('/class/all', {
  params: {
    tag: 'CodingWizard',
  },
});

const getClassById = (cid) => endpoint.get(`/class/${cid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const createClass = (data) => endpoint.post('/class', data, {
  params: {
    tag: 'CodingWizard',
  },
});

const updateClass = (data, cid) => endpoint.put(`/class/${cid}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

const deleteClass = (data, cid) => endpoint.delete(`/class/delete/${cid}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

const getMyClassList = (cwId) => endpoint.get(`/class/my_class/${cwId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getClassByTeacherId = (cwId) => endpoint.get(`/class/teacher/${cwId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getClassList,
  getClassById,
  createClass,
  updateClass,
  deleteClass,
  getMyClassList,
  getClassByTeacherId,
};
